import React from "react";
import PropTypes from "prop-types";

const ButtonGroup = ({ style, styles, children, ...rest}) => (
  <div data-testid="button-group" className="button-group-component" style={style || styles.base} {...rest}>
    {children}
  </div>
);

ButtonGroup.propTypes = {
  style: PropTypes.object,
  styles: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

ButtonGroup.defaultProps = {
  styles: {}
}


export default ButtonGroup;
